import intervalMixin from '@/mixins/interval'

export default {
  mixins: [intervalMixin],
  data () {
    const cached = this.$store.state.passcode.storagePasscode
    let passcodeTimerSeconds = 0
    if (cached) {
      const currentTime = new Date().getTime()
      if (cached.requestExpires && currentTime < cached.requestExpires) {
        passcodeTimerSeconds = Math.round((cached.requestExpires - currentTime) / 1000)
      }
    }
    return {
      form: {
        pin: ''
      },
      passcodeTimerSeconds
    }
  },
  watch: {
    'form.pin' (value) {
      if (value.length === 4 && value.match(/^[0-9]*$/)) {
        this.$emit('pin-enter', value)
      }
    }
  },
  mounted () {
    this.$refs.pinInput.focus()
    this.passcodeTimer()
  },
  methods: {
    passcodeTimer () {
      if (this.passcodeTimerSeconds > 0) {
        this.passcodeTimerSeconds--
        this.setTimeout(this.passcodeTimer, 1000)
      }
    }
  }
}
